import { IconButton } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { constants } from '../../../constants';

const device = {
  desktop: `(min-width:${constants.displaySizes.desktop})`,
  largeDesktop: `(min-width:${constants.displaySizes.largeDesktop})`,
  smallDesktop: `(min-width:${constants.displaySizes.smallDesktop})`,
  smallMobile: `(max-width:${constants.displaySizes.smallMobile})`,
  mobile: `(max-width:${constants.displaySizes.mobile})`,
  tablet: `(min-width:${constants.displaySizes.tablet})`,
};

export const StyleSocialLinkLayout = styled.div`
  display: flex;
  column-gap: 12px;
  flex-wrap: wrap;

  @media ${device.smallMobile} {
    max-width: 288px;
  }
  @media ${device.mobile} {
    max-width: 319px;
  }
`;

export const SocialButton = styled(IconButton)``;
